import { Box, Divider, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import clsx from 'clsx';
import s from '../ProviderReviewSummary.module.scss';

const CompletedProjectCount = ({
  isMobileView,
  completedProjectsCount,
}: {
  isMobileView: boolean;
  completedProjectsCount: number;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Box marginRight="3px">
        <Text size="medium" weight="normal">
          {completedProjectsCount}
        </Text>
      </Box>
      <Box>
        <Text
          size="tiny"
          weight="thin"
          className={clsx(s.subText, isMobileView && s.mobile)}
          skin="standard"
        >
          {t(
            isMobileView
              ? 'profile-page-mobile-completed-project.icu'
              : 'profile-page-desktop-completed-project.icu',
            {
              number: completedProjectsCount,
            },
          )}
        </Text>
      </Box>
    </>
  );
};

export default CompletedProjectCount;
